const EstadoCotizacionConstants = {
  REGISTRADO: "REGI",
  ACEPTADO: "ACEP",
  RECHAZADO: "RECH",
};

const EstadoNotificacionConstants = {
  PENDIENTE: "PENDIENTE",
  ENVIADA: "ENVIADA",
  FALLIDA: "FALLIDA",
};
const EstadoPedidoVentaConstants = {
  BORRADOR: "BORRADOR",
  CONFIRMADO: "CONFIRMADO",
  DESPACHADO: "DESPACHADO",
  FINALIZADO: "FINALIZADO",
  CANCELADO: "CANCELADO",
};

export {
  EstadoCotizacionConstants,
  EstadoNotificacionConstants,
  EstadoPedidoVentaConstants,
};
